<div class="campaigns-grid">
  <article class="campaign-card" *ngFor="let campanha of campanhas"
    (click)="callRouteDetalheCampanha(campanha?.id, campanha?.titulo)">
    <!-- Card Media / Badges -->
    <div class="campaign-card-img">
      <img [src]="campanha?.imgPreview || campanha?.fotoUrl || '/images/campanha-1.png'"
        [alt]="campanha?.titulo || 'Imagem da campanha'" loading="lazy" />
      <div class="campaign-card-badges">
        <div class="cc-badges-left">
          <span class="cc-badge-cat">
            <i [class]="getCategoryIcon(campanha?.categoria?.descricao)"></i>
            {{ campanha?.categoria?.descricao || 'Causa Social' }}
          </span>
          <span class="cc-badge-type" *ngIf="campanha?.tipoFinanciamento || campanha?.tipoFinanciamentoENUM">
            <i [class]="getTipoFinanciamentoIcon(campanha?.tipoFinanciamentoENUM || campanha?.tipoFinanciamento)"></i>
            {{ campanha?.tipoFinanciamento || getTipoFinanciamentoLabel(campanha?.tipoFinanciamentoENUM) }}
          </span>
        </div>
        <span class="cc-badge-days" [ngClass]="getDaysClass(campanha?.diasRestantes || 0)" *ngIf="!campanha?.expirado">
          <i class="fas fa-clock"></i>
          {{ campanha?.diasRestantes || 0 }} dias
        </span>
        <span class="cc-badge-days urgent" *ngIf="campanha?.expirado">
          <i class="fas fa-clock"></i> Encerrada
        </span>
      </div>
      <span class="cc-badge-featured" *ngIf="campanha?.isDestaque || campanha?.destaque || campanha?.campanhaDestaque">
        <i class="fas fa-fire"></i> Em Destaque
      </span>
    </div>

    <!-- Card Body -->
    <div class="campaign-card-body">
      <h3 class="campaign-card-title">{{ campanha?.titulo }}</h3>

      <div class="campaign-card-org">
        <i class="fas fa-circle-check"></i>
        <span>{{ campanha?.utilizadorNome || 'Autor não informado' }} · {{ campanha?.provincia?.descricao || 'Luanda'
          }}</span>
      </div>

      <p class="campaign-card-desc line-clamp-2">
        {{ campanha?.descricaoCurta || campanha?.descricao || 'Sem descrição informada para esta campanha.' }}
      </p>

      <!-- Progress Section -->
      <div class="campaign-card-progress">
        <div class="cc-progress-top">
          <span class="cc-amount">{{ formatShortNum(campanha?.valorArrecado) }}</span>
          <span class="cc-pct-badge" [ngClass]="getPctClass(getPercent(campanha))">
            {{ getPercent(campanha) }}%
          </span>
        </div>

        <div class="cc-progress-bar">
          <div class="cc-progress-fill" [ngClass]="getPctClass(getPercent(campanha))"
            [style.width.%]="getPercent(campanha) > 100 ? 100 : (getPercent(campanha) < 0.5 && getPercent(campanha) > 0 ? 1 : getPercent(campanha))">
          </div>
        </div>

        <div class="cc-meta">
          <div class="cc-meta-item">
            <i class="fas fa-users"></i>
            <span>{{ campanha?.totalDoadores || 0 }} doadores</span>
          </div>
          <div class="cc-meta-item" [class.urgent]="(campanha?.diasRestantes || 0) <= 10 && !campanha?.expirado">
            <i class="fas fa-clock"></i>
            <span *ngIf="!campanha?.expirado">{{ campanha?.diasRestantes || 0 }} dias restantes</span>
            <span *ngIf="campanha?.expirado">Encerrada</span>
          </div>
          <div class="cc-meta-item">
            <i class="fas fa-bullseye"></i>
            <span>{{ formatShortNum(campanha?.metaArrecadar) }} meta</span>
          </div>
        </div>
      </div>

      <!-- Action Button -->
      <button type="button" class="btn btn-primary btn-full btn-rounded" style="margin-top: auto;"
        (click)="callRouteFinacy(campanha?.id, campanha?.titulo, $event)"
        *ngIf="!campanha?.expirado && (campanha?.EstadoCampanhaENUM === 4 || campanha?.estadoCampanhaENUM === 4 || !campanha?.estadoCampanhaENUM)">
        <i class="fas fa-heart"></i>
        <span>Financiar Projecto</span>
      </button>
    </div>

    <!-- Reactions Component (Card Footer) -->
    <app-reactions [campanhaID]="campanha?.id" [curtidaID]="campanha?.curtidas?.curtidasId"
      [totalCurtidas]="campanha?.curtidas?.totalCurtidas || 0"
      [totalComentarios]="campanha?.totalComentarios || campanha?.comentarios?.length || 0"
      [campanhaTitulo]="campanha?.titulo"
      (commentAdded)="onCommentAdded(campanha)"></app-reactions>
  </article>
</div>